// src/components/dialog/Preloader.tsx

import { HomeTwoTone, RefreshTwoTone } from '@mui/icons-material'
import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Tooltip,
  useTheme,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { svgConstants as SVG } from '../../constants'

const reloadPage = () => location.reload()

type Props = {
  caption?: string
  isLoading: boolean
  error?: string | null
  percentage?: number
}

export const Preloader = ({
  caption = 'laden ...',
  isLoading,
  error = null,
  percentage,
}: Props) => {
  const theme = useTheme()
  const { white: color } = theme.palette

  const navigate = useNavigate()

  // handler

  const gotoHome = () => navigate('/')

  return (
    <Dialog open={isLoading}>
      <DialogTitle>
        <Box
          component={'img'}
          src={SVG.KARMA_LOGO}
          sx={{ width: 40, height: 40, mr: 2 }}
        />
        {error ? 'API Fehler' : caption}
      </DialogTitle>

      <Collapse in={isLoading && !error}>
        <DialogContent>
          {percentage !== undefined ? (
            <LinearProgress variant={'determinate'} value={percentage} />
          ) : (
            <LinearProgress />
          )}
        </DialogContent>
      </Collapse>

      <Collapse in={error !== null}>
        <DialogContent sx={{ py: 0 }}>
          <Alert severity={'error'}>
            <AlertTitle>{error}</AlertTitle>
          </Alert>
        </DialogContent>

        <DialogActions>
          <Tooltip title={'Startseite'}>
            <IconButton onClick={gotoHome} sx={{ color }}>
              <HomeTwoTone />
            </IconButton>
          </Tooltip>

          <Tooltip title={'Wiederholen'}>
            <IconButton onClick={reloadPage} sx={{ color }}>
              <RefreshTwoTone />
            </IconButton>
          </Tooltip>
        </DialogActions>
      </Collapse>
    </Dialog>
  )
}
